
import vClickOutside from 'v-click-outside';

export default {
  name: "FilterDropdownWrapperMobile",

  directives: {
    clickOutside: vClickOutside.directive,
  },

  props: {
    filterDisplayValue: {
      type: String,
      default: ''
    },
    // displayValue: {
    //   type: String,
    //   default: '',
    // },
    filterTitle: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dropdownActive: false,
    }
  },

  methods: {
    toggleDropdown() {
      // console.debug('dropdown wrapper click');
      // this.dropdownActive = !this.dropdownActive;
      if ( this.dropdownActive ) {
        this.closeDropdown();
      } else {
        this.dropdownActive = true;
      }
    },
    closeDropdown() {
      if ( this.dropdownActive ) {
        this.$emit('on-close', false);
        this.dropdownActive = false;
      }
    }
  }
}
